export function scrollAnimation() {
    let animateElement = $('.has-animate');
    let scrolled = $(window).scrollTop();
    let addHeight = parseInt(window.innerHeight * 0.95);

    $(window).on('load', function () {
        animateElement.each(function () {
            let $this = $(this);
            let elementTop = parseInt($this.offset().top);
            if ((scrolled + addHeight) >= elementTop) {
                $this.addClass('animated');
            }
        });
    });
    $(window).on('scroll', function () {
        scrolled = $(window).scrollTop();
        animateElement.each(function () {
            let $this = $(this);
            let elementTop = parseInt($this.offset().top);
            if ((scrolled + addHeight) >= elementTop) {
                $this.addClass('animated');
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/scrollAnimation.js